import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import * as actionTypes from '~/store/actions/actionTypes';
import { filterOptions as FilterOptionTypes } from '~/store/reducers/historyFilterOptions';

import {
  FormControl,
  MenuProps,
  MenuItem,
  ListItemText,
} from '../sharedStyles';

const GenericCalllogFilterSelect = (props: any) => {
  const dispatch = useDispatch();

  const { filterName, dataSelected, children, ...addtionalProps } = props;

  const [open, setOpen] = useState<boolean>(false);

  const selectId = `select-${filterName}`.toLocaleLowerCase().trim();

  const getDefaultValue = () => {
    if (open || (dataSelected.length > 0 && !open)) {
      return dataSelected;
    }
    return [filterName];
  };

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    // TODO: Change filter option type to be generic
    dispatch({
      type: actionTypes.SET_HISTORY_FILTER_OPTIONS,
      option: FilterOptionTypes.queues,
      payload: event.target.value,
      extra: { resetCallItems: true },
    });
  };

  return (
    <FormControl variant="outlined" hasselecteditems={dataSelected?.length}>
      <Select
        id={selectId}
        labelId={selectId}
        multiple
        disableUnderline
        input={<Input />}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={handleChange}
        value={getDefaultValue()}
        // @ts-ignore
        MenuProps={MenuProps}
        {...addtionalProps}>
        <MenuItem firstItem value={filterName} disabled>
          <ListItemText firstItem primary={filterName} />
        </MenuItem>
        {children}
      </Select>
    </FormControl>
  );
};

export default GenericCalllogFilterSelect;
